// размер приложения для версии для vk.com https://vk.com/editapp?id=51478948&section=options
export const APP_DESKTOP_WIDTH = 630;

export const isDev = process.env.NODE_ENV === 'development';

export const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const headers = {
    'Content-Type': 'application/json',
    'Client-Timezone': timeZone,
    Accept: 'application/json',
};

// локально ходим через проксю из package.json
export const apiUrl =
    process.env.NODE_ENV === 'development' ? '/la/api/v1/lead_ads' : 'https://ad.mail.ru/la/api/v1/lead_ads';

export enum USER_ID_FROM {
    VK = 'vk',
    OK = 'ok',
    MAIL = 'mail',
    SDK = 'sdk',
}

export const yclientsApiUrl = 'https://api.yclients.com/api/v1';

export const companyId = 936867;

//  PHONE VERIFICATION CONST
export const VERIFICATION_PHONE_SEND_LIMIT_IN_MS = 60 * 1000;
export const VERIFICATION_SIGN_UP_LIMIT_IN_MS = 3 * 1000;
export const CODE_LENGTH = 4;
